import classnames from 'classnames';
import React, { FC } from 'react';

import Icon from '@ant-design/icons';

import { ReactComponent as Pause } from '@skytvnz/sky-app-style/lib/assets/svg/icons/icon_pause.svg';
import { ReactComponent as Play } from '@skytvnz/sky-app-style/lib/assets/svg/icons/icon_play.svg';
import { ReactComponent as PlayBack } from '@skytvnz/sky-app-style/lib/assets/svg/icons/icon_scrubbing_back.svg';
import { ReactComponent as PlayForward } from '@skytvnz/sky-app-style/lib/assets/svg/icons/icon_scrubbing_forward.svg';

import styles from './styles.module.scss';

export interface Props {
  isShow?: boolean;

  isLivePlayer?: boolean;
  durationJump: number;
  isPlaying: boolean;
  isAdPlaying: boolean;
  onIsPlayingChange: (newIsPlaying: boolean) => void;
  onPlayBack: () => void;
  onPlayForward: () => void;
}

const PlaybackPanel: FC<Props> = ({
  durationJump,
  isAdPlaying,
  isPlaying,
  onIsPlayingChange,
  onPlayBack,
  onPlayForward,
}) => {
  const renderControlButton = ({
    onClick,
    title,
    testId,
    name,
    icon,
    buttonClass,
    durationClass,
  }: {
    onClick: () => void;
    title: string;
    testId: string;
    name: string;
    icon: FC;
    buttonClass: string;
    durationClass?: string;
    durationJump?: number;
  }) => (
    <button
      type="button"
      className={classnames(styles.controlButton, buttonClass)}
      onClick={onClick}
      title={title}
      data-testid={testId}
      name={name}
    >
      <Icon className={styles.buttonIcon} component={icon} />
      {durationClass && durationJump !== undefined && (
        <span className={classnames(styles.durationJump, durationClass)}>{durationJump}</span>
      )}
    </button>
  );

  return (
    <div className={styles.playbackPanel}>
      {!isAdPlaying &&
        renderControlButton({
          onClick: onPlayBack,
          title: 'Backward (←)',
          testId: 'video-player-playback-back',
          name: 'Player playback back button',
          icon: PlayBack,
          buttonClass: styles.playBackBtn,
          durationClass: styles.durationJumpBack,
          durationJump,
        })}

      {renderControlButton({
        onClick: () => onIsPlayingChange(!isPlaying),
        title: `${isPlaying ? 'Pause' : 'Play'} (k)`,
        testId: 'video-player-playback-play-pause',
        name: 'Player playback play/pause button',
        icon: isPlaying ? Pause : Play,
        buttonClass: styles.playBtn,
      })}

      {!isAdPlaying &&
        renderControlButton({
          onClick: onPlayForward,
          title: 'Forward (→)',
          testId: 'video-player-playback-forward',
          name: 'Player playback forward button',
          icon: PlayForward,
          buttonClass: styles.playForwardBtn,
          durationClass: styles.durationJumpForward,
          durationJump,
        })}
    </div>
  );
};

export default PlaybackPanel;
